import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './circle-badge.styl'

export default class CircleBadge extends Component {
  static propTypes = {
    children: PropTypes.any,
    small: PropTypes.bool,
    plain: PropTypes.bool,
    large: PropTypes.bool,
    medal: PropTypes.bool,
    padded: PropTypes.bool,
    defaultColor: PropTypes.bool,
    className: PropTypes.string,
    colorClass: PropTypes.string,
    style: PropTypes.object
  }

  static defaultProps = {
    small: false,
    large: false,
    plain: false,
    medal: false,
    padded: false,
    colorClass: 'none'
  }

  render() {
    const {
      large,
      small,
      plain,
      medal,
      padded,
      colorClass,
      className,
      defaultColor,
      style
    } = this.props

    const classNames = [styles[colorClass]]

    small && classNames.push(styles.small)
    large && classNames.push(styles.large)
    plain && classNames.push(styles.plain)
    medal && classNames.push(styles.medal)
    padded && classNames.push(styles.padded)
    defaultColor && classNames.push(styles.defaultColor)
    className && classNames.push(className)

    return (
      <div className={classNames.join(' ')} style={style}>
        {this.props.children}
      </div>
    )
  }
}
